import React from "react";
import { Outlet } from "react-router-dom";

import Wrapper from "../components/Wrapper";
import Sidebar from "../components/sidebar/Sidebar";
import Main from "../components/Main";
import Navbar from "../components/navbar/Navbar";
import Content from "../components/Content";
import Footer from "../components/Footer";
import Settings from "../components/Settings";

import dashboardItems from "../components/sidebar/dashboardItems";
import { Briefcase, Home } from "react-feather";

export interface NavItemType {
  href: string;
  icon: React.FC<any>;
  title: string;
}

const items = [
  {
    href: "/",
    icon: Home,
    title: "Visualisations",
  },
  {
    href: "/companies",
    icon: Briefcase,
    title: "Companies List",
  }
]
const Dashboard: React.FC = ({ children }) => (
  <React.Fragment>
    <Wrapper>
      {/* <Sidebar items={dashboardItems} admin={false} /> */}
      <Main>
        {/* //@ts-ignore */}
        <Navbar items={dashboardItems} admin={false} />
        <Content>
          {children}
          <Outlet />
        </Content>
        <Footer />
      </Main>
    </Wrapper>
    {/* <Settings /> */}
  </React.Fragment>
);

export default Dashboard;
